/* eslint 'use-isnan' : 'off', eqeqeq: 'off', no-unused-vars: 'off'  */
import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from 'classnames';
import { GetTemperatureWidgetDetails, SaveTemperature } from 'action/facilitiesAction';
import Temperature from 'Resources/Temperature';
import DMResources from 'Resources/DMResources.en-US';
// import styles from 'components/FacilityRequestComponents/Maintenance/maintenance.module.css';
import ComfortStyles from 'components/FacilityRequestComponents/Comfort/Modules/Comfort.module.css';
import thermostat from 'Assets/icons/Icons__thermostat3.svg';
import fire from 'Assets/icons/Icons__fire2.svg';
import snowflake from 'Assets/icons/Icons__snowflake.svg';
import {setAmplitudeEvent} from 'amplitude/amplitude';
// import 'Assets/styles/temperatureWidget.css';


let m_WriteDetails = null, m_SetpointValue = null, m_Offset = null, mHeatCoolValue = '', mIsAnalogDifferential = false;

//eslint-disable-next-line
var write_object = {}; var prev_Value = null;

class TemperatureWidget extends Component {


    componentWillMount() {
        let ZoneId = localStorage.getItem('ZoneID');
        // let ZoneId =  this.props.selectedZoneID;
        this.initialiseWidget(ZoneId);
        let TimeOut = (localStorage.getItem("PageRefreshInterval")!=undefined && localStorage.getItem("PageRefreshInterval")!=null && localStorage.getItem("PageRefreshInterval")!="") ? localStorage.getItem("PageRefreshInterval"):10000;
        this.interval = setInterval(this.refreshComponent,TimeOut); // Set up interval to refresh every 10 seconds
    }


    componentWillReceiveProps(nextProps) {
        if (this.props.selectedZoneID !== nextProps.selectedZoneID) {
            this.initialiseWidget(nextProps.selectedZoneID);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval); // Clear interval when component unmounts
    }
    constructor(props) {
        super(props);
        this.state = {
            SpaceTemp: '---',
            TempSetpoint: '---',
            minValue: 70,
            maxValue: 75,
            minReached: true,
            maxReached: true,
            IsHeatVisible: false,
            UnitText: '',
            widgetDisabledCode: 0
        };
        this.ChangeTemperature = this.ChangeTemperature.bind(this);
        this.ExecuteWidgetWrite = this.ExecuteWidgetWrite.bind(this);
        this.initialiseWidget = this.initialiseWidget.bind(this);
        this.refreshComponent = this.refreshComponent.bind(this);
    }

    render(TempWidgetDetails) {
        let messageContent = null;
        let widget_disabled_message = <div className={ComfortStyles.fieldrow} ><p className={ComfortStyles.messageText}>Comfort controls are not available for this space (Code: {this.state.widgetDisabledCode}).</p></div>;

        if (this.state.maxReached && this.state.minReached) {
            messageContent = widget_disabled_message;
        }

        return (
            <div>
                {messageContent}
                <div className={ComfortStyles.widgetFieldrow}>
                    <div className={ComfortStyles.widgetContainer}>

                        <div className={ComfortStyles.widgetMainContent}>
                            <div className={ComfortStyles.widgetMiniContainer}>
                                <div className={ComfortStyles.spaceTempContainer}>
                                    <img src={thermostat} alt="Trane Logo" className={ComfortStyles.thermoIcon} />
                                    <h2 className={ComfortStyles.spaceTempText}>{this.state.SpaceTemp}{" " + this.state.UnitText}</h2>
                                </div>
                                <div className={ComfortStyles.setPointTempContainer}>
                                    <button disabled={this.state.maxReached} onClick={() => { this.ChangeTemperature('Max'); this.ExecuteWidgetWrite() }}
                                        className={classnames(ComfortStyles.widgetButton, (this.state.maxReached) ? ComfortStyles.inactiveButton : ComfortStyles.upDefaultButton)}>
                                        <i className={ComfortStyles.upArrow}></i>
                                    </button>

                                    <div className={ComfortStyles.settingContainer}>
                                        <div className={ComfortStyles.settingMiniContainer} >
                                            <p>SETTING</p>
                                            <p>{this.state.TempSetpoint}{" " + (this.state.TempSetpoint != "---" ? this.state.UnitText : "")}</p>
                                        </div>
                                    </div>
                                    <button disabled={this.state.minReached} onClick={() => { this.ChangeTemperature('Min'); this.ExecuteWidgetWrite() }}
                                        className={classnames(ComfortStyles.widgetButton, ComfortStyles.floatRight, (this.state.minReached) ? ComfortStyles.inactiveButton : ComfortStyles.downDefaultButton)}>
                                        <i className={ComfortStyles.downArrow}></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={ComfortStyles.widgetSideContent}>
                            <div className={ComfortStyles.systemModeContainer}>
                                <p className={ComfortStyles.systemModelabel}>SYSTEM MODE</p>
                                {this.state.IsHeatVisible ? <p className={ComfortStyles.systemModeValue}> <span>  <img src={fire} alt="Heat icon" className={ComfortStyles.systemModeIcon} />  </span>HEAT </p> : ""}
                                {!this.state.IsHeatVisible ? <p className={ComfortStyles.systemModeValue}> <span>  <img src={snowflake} alt="Snow flake" className={ComfortStyles.systemModeIcon} />  </span>COOL </p> : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    initialiseWidget(propsZoneID) {

        let ZoneId = propsZoneID;

        if (ZoneId !== null || ZoneId !== undefined) {

            prev_Value = null; mIsAnalogDifferential = false;

            const actionResponse = this.props.GetTemperatureWidgetDetails(ZoneId);
            actionResponse.then((result) => {
                if (this.props.TempWidgetDetails !== undefined && this.props.TempWidgetDetails !== null) {
                    let data = null, Detail = null, JsonObj = [];
                    let zone_name = localStorage.getItem("ZoneName");
                    var l_keys = ["statusValue", "requestValue", "requestMinValue", "requestMaxValue", "offsetValue", "heatCoolValue", "occupancyStatus", "priorityArray", "activePriority", "outOfService"];
                    let l_SCWidgetIds = ["IdSpw", "IdSpw:widget_requestValue", "IdSpw:widget_requestMinValue", "IdSpw:widget_requestMaxValue", "IdSpw:widget_offsetValue", "IdSpw:widget_heatCoolValue", "IdSpw:widget_occupancyStatus", "IdSpw:widget_priorityArray", "IdSpw:widget_activePriority", "IdSpw:widget_outOfService"];
                    var l_BCUWidgetIds = ["DISPID2", "DISPID.RequestValue", "DISPID.MinValue", "DISPID.MaxValue", "DISPID.OffsetValue", "DISPID8", "DISPID67", "DISPID.PriorityArray", "DISPID.ActivePriority", "DISPID.OutOfService"];
                    data = this.props.TempWidgetDetails;
                    try {
                        if (data.status != undefined && data.status === 500) {

                        } else {
                            Detail = data;
                            let m_Result = Detail.temperatureData;
                            m_WriteDetails = Detail.writeData;
                            let l_AnalogDifferential = null; let l_UCMAnalogValue = Detail.uCMAnalogValue;

                            if (Detail.controlPanelType == 100) { //Set Default BCU Point Readings

                                //Set HEAT/COOL Mode
                                if ((Detail.controlObjectType == 181 || Detail.controlObjectType == 187)) {
                                    if (m_Result.dataPointValues[4].displayValue !== "---" && m_Result.dataPointValues[1].displayValue !== "---") {
                                        if (Number(m_Result.dataPointValues[1].displayValue) <= Number(m_Result.dataPointValues[4].displayValue)) {
                                            mHeatCoolValue = "HEAT";
                                        }
                                        else {
                                            mHeatCoolValue = "COOL";
                                        }
                                    }
                                }
                                else {
                                    mHeatCoolValue = Temperature.setHeatCoolvisible(Detail.controlObjectType, Detail.heatCoolValue);
                                }


                                if (l_UCMAnalogValue != "0" && m_Result.dataPointValues[1].displayValue != null && m_Result.dataPointValues[4].displayValue != null) {
                                    if (m_Result.dataPointValues[4].displayValue == "---") {
                                        if (mHeatCoolValue != undefined) {
                                            if (mHeatCoolValue == "HEAT") {
                                                l_AnalogDifferential = (Number(m_Result.dataPointValues[1].displayValue) + Number(l_UCMAnalogValue)).toString();
                                            }
                                            else {
                                                l_AnalogDifferential = (Number(m_Result.dataPointValues[1].displayValue) - Number(l_UCMAnalogValue)).toString();
                                            }

                                            m_Result.dataPointValues[4].displayValue = l_AnalogDifferential;
                                            m_Result.dataPointValues[4].displayText = l_AnalogDifferential;
                                            mIsAnalogDifferential = true;
                                        }
                                    }
                                }

                                if (m_Result.dataPointValues[3] != null) //Set Occupancy
                                {
                                    switch (Number(m_Result.dataPointValues[3].displayValue)) { // Supply BCU Occupancy values as accepted by the widget
                                        case 0:
                                        case 1:
                                        case 6:
                                        case 7:
                                        case 8:
                                            m_Result.dataPointValues[3].displayValue = "2";
                                            m_Result.dataPointValues[3].displayText = "2";
                                            break;
                                        default:
                                            m_Result.dataPointValues[3].displayValue = "1";
                                            m_Result.dataPointValues[3].displayText = "1";

                                    }
                                }

                                var l_BCUOffset = "0"; //Set BCU Offset to 0 by default
                                var l_IsReferenced = Detail.isReferenced;

                                var l_PriorityArr = { displayText: "8", displayValue: "8", htmlElementId: m_Result.dataPointValues[0].dataPointControllerId + '-DISPID.PriorityArray', units: m_Result.dataPointValues[0].units, dataPointControllerId: m_Result.dataPointValues[0].dataPointControllerId };
                                var l_ActPriority = { displayText: "8", displayValue: "8", htmlElementId: m_Result.dataPointValues[0].dataPointControllerId + '-DISPID.ActivePriority', unitsText: m_Result.dataPointValues[0].units, dataPointControllerId: m_Result.dataPointValues[0].dataPointControllerId };

                                if (mIsAnalogDifferential) {
                                    l_BCUOffset = Detail.uCMAnalogValue;
                                }

                                var l_OffsetVal = { displayText: l_BCUOffset, displayValue: l_BCUOffset, htmlElementId: m_Result.dataPointValues[0].dataPointControllerId + '-DISPID.OffsetValue', units: m_Result.dataPointValues[0].units, dataPointControllerId: m_Result.dataPointValues[0].dataPointControllerId };

                                if (m_Result.dataPointValues[5] == null) { //out of service
                                    var l_OutOfService = { displayText: "0", displayValue: "0", htmlElementId: m_Result.dataPointValues[0].dataPointControllerId + '-DISPID.OutOfService', units: m_Result.dataPointValues[0].units, dataPointControllerId: m_Result.dataPointValues[0].dataPointControllerId };
                                    m_Result.dataPointValues.push(l_OutOfService);
                                }

                                if (l_IsReferenced) { //Disable if referencerStatus is 3 - signals bas point is referenced
                                    m_Result.dataPointValues[5].displayText = "1";
                                    m_Result.dataPointValues[5].displayValue = "1";
                                }

                                if (m_Result.dataPointValues[2] != null) {
                                    if (mHeatCoolValue == "HEAT") // set heat/cool mode according to widget accepted values
                                    {
                                        m_Result.dataPointValues[2].displayText = "2";
                                        m_Result.dataPointValues[2].displayValue = "2";
                                    }
                                    else {
                                        m_Result.dataPointValues[2].displayText = "1";
                                        m_Result.dataPointValues[2].displayValue = "1";
                                    }
                                }

                                m_Result.dataPointValues.push(l_PriorityArr);
                                m_Result.dataPointValues.push(l_ActPriority);
                                m_Result.dataPointValues.push(l_OffsetVal);

                            }

                            for (let i = 0; i < m_Result.dataPointValues.length; i++) {
                                let HtmlId = m_Result.dataPointValues[i].htmlElementId;
                                for (let j = 0; j < l_SCWidgetIds.length; j++) {
                                    if (Detail.controlPanelType != 100) {
                                        if (HtmlId === l_SCWidgetIds[j] + zone_name) {
                                            JsonObj[l_keys[j]] = m_Result.dataPointValues[i];
                                            break;
                                        }
                                    }

                                    else {

                                        if (Detail.controlObjectType == 165 || Detail.controlObjectType == 169 || Detail.controlObjectType == 185) {
                                            if (m_Result.dataPointValues[5].displayValue == "1") {
                                                m_Result.dataPointValues[5].displayValue = "0";
                                            }
                                            else {
                                            m_Result.dataPointValues[5].displayValue = "1";
                                            }
                                        }
                                        else if (Detail.controlObjectType == 150 && m_Result.dataPointValues[6] != null) {
                                            if (m_Result.dataPointValues[5].displayValue == "0" && m_Result.dataPointValues[6].displayValue == "0")
                                                m_Result.dataPointValues[5].displayValue = "0";
                                            else
                                                m_Result.dataPointValues[5].displayValue = "1";
                                        }

                                        if (i == 4) {
                                            JsonObj[l_keys[1]] = m_Result.dataPointValues[i];
                                            break;
                                        }
                                        else if (i == 5) {
                                            JsonObj[l_keys[9]] = m_Result.dataPointValues[i];
                                            break;
                                        }
                                        else if (i == 1 && (Detail.controlObjectType == 154 || Detail.controlObjectType == 155)) {
                                            JsonObj[l_keys[0]] = m_Result.dataPointValues[i];
                                            break;
                                        }
                                        else if (HtmlId === m_Result.dataPointValues[i].dataPointControllerId + '-' + l_BCUWidgetIds[j]) {
                                            JsonObj[l_keys[j]] = m_Result.dataPointValues[i];
                                            break;
                                        }

                                    }

                                }
                            }

                            // if (Detail.ControlPanelType == 100 && (Detail.ControlObjectType == 154 || Detail.ControlObjectType == 155) && Detail.DataPointValues[2] != null) {
                            //     m_Result.DataPointValues[2].DisplayValue = l_HeatCoolValue;
                            //     m_Result.DataPointValues[2].DisplayText = l_HeatCoolValue;
                            // }

                            let lUnitText = (m_Result.dataPointValues[0].units !== "" && m_Result.dataPointValues[0].units !== -1) ? DMResources.FamilyList('Enum3046.' + m_Result.dataPointValues[0].units + '.Text') : "";
                            let lSpaceTemperature = data.temperatureData.dataPointValues[0].displayText; //localStorage.getItem("TempValue");
                            let lSetPoint = (JsonObj["statusValue"].displayValue !== "---") ? ((Number(JsonObj["statusValue"].displayValue).toFixed(0) == "NaN") ? "---" : Number(JsonObj["statusValue"].displayValue).toFixed(0)) : "---"; //Number(m_Result.DataPointValues[0].DisplayValue).toFixed(0);
                            m_SetpointValue = (JsonObj["statusValue"].displayValue !== "---") ? parseFloat(JsonObj["statusValue"].displayValue) : "---";
                            m_Offset = JsonObj["offsetValue"] != undefined ? ((JsonObj["offsetValue"].displayValue !== "---") ? parseFloat(JsonObj["offsetValue"].displayValue) : 0) : 0;
                            //let mHeatCoolValue = Temperature.setHeatCoolvisible(m_Result, data.ControlPanelType, data.ControlObjectType, false, 0)

                            if (Detail.controlPanelType != 100) {
                                if (JsonObj["requestValue"] != undefined) {
                                    if (JsonObj["requestValue"].displayValue !== "---" && JsonObj["statusValue"].displayValue !== "---") {
                                        if (Number(JsonObj["statusValue"].displayValue) <= Number(JsonObj["requestValue"].displayValue)) {
                                            mHeatCoolValue = "HEAT";
                                        }
                                        else {
                                            mHeatCoolValue = "COOL";
                                        }
                                    }
                                }
                            }


                            let IsHeatVisible1 = (mHeatCoolValue === "HEAT") ? true : false;
                            this.setState({ IsHeatVisible: IsHeatVisible1, SpaceTemp: lSpaceTemperature, TempSetpoint: lSetPoint, minValue: Number(Detail.minimumSetting).toFixed(0), maxValue: Number(Detail.maximumSetting).toFixed(0), UnitText: lUnitText });

                            let HasWidgetDisable = Temperature.DetermineDisabledStateUpdated(JsonObj);

                            if (HasWidgetDisable.isDisable) {
                              
                                 setAmplitudeEvent("Comfort control message", { "Primary Offering": "TS", "Message type": "Code "+ HasWidgetDisable.Code });
                                this.setState({ minReached: true, maxReached: true, widgetDisabledCode: HasWidgetDisable.Code });
                            } else {
                                this.setState({ minReached: false, maxReached: false });
                                if (Number(lSetPoint) <= Number(Detail.minimumSetting).toFixed(0))
                                    this.setState({ minReached: true });
                                if (Number(lSetPoint) >= Number(Detail.maximumSetting).toFixed(0))
                                    this.setState({ maxReached: true });
                            }
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            })
        }

    }


    ChangeTemperature(Type) {
        var l_setpoint_value = 0;

        if (Number(this.state.TempSetpoint) !== NaN) {
            if (Type === 'Max') {
                if ((Number(this.state.TempSetpoint) + 1) > Number(this.state.minValue)) {
                    this.setState({ minReached: false });
                }
                if ((Number(this.state.TempSetpoint) + 1) === Number(this.state.maxValue)) {
                    this.setState({ maxReached: true });
                }
                if ((Number(this.state.TempSetpoint) + 1) <= Number(this.state.maxValue)) {
                    this.setState({ TempSetpoint: Number(this.state.TempSetpoint) + 1 });
                }
               setAmplitudeEvent( "Comfort Control widget", { "Primary Offering": "TS","Adjustment type": "increment"});
                m_SetpointValue = m_SetpointValue + 1;

            } else {
                if ((Number(this.state.TempSetpoint) - 1) < Number(this.state.maxValue)) {
                    this.setState({ maxReached: false });
                }
                if ((Number(this.state.TempSetpoint) - 1) === Number(this.state.minValue)) {
                    this.setState({ minReached: true });
                }
                if ((Number(this.state.TempSetpoint) + 1) >= Number(this.state.minReached)) {
                    this.setState({ TempSetpoint: Number(this.state.TempSetpoint) - 1 });
                }

                setAmplitudeEvent( "Comfort Control widget", { "Primary Offering": "TS","Adjustment type": "decrement"});
                m_SetpointValue = m_SetpointValue - 1;
            }

            var ObjectId = (m_WriteDetails.childobjectid != null && m_WriteDetails.childobjectid != "") ? Number(m_WriteDetails.childobjectid) : Number(m_WriteDetails.objectid);
            var PropertyId = (m_WriteDetails.propertyid != null && m_WriteDetails.propertyid != "") ? m_WriteDetails.propertyid : "-1";
            var Device = (m_WriteDetails.device != null && m_WriteDetails.device != "") ? m_WriteDetails.device : 0;
            if (mHeatCoolValue === "HEAT") {
                l_setpoint_value = m_SetpointValue + m_Offset;
            }
            else {
                l_setpoint_value = m_SetpointValue - m_Offset;
            }

            write_object = {
                "ArrayIndex": -1,
                "DeviceInstance": Device,
                "ObjectName": m_WriteDetails.objectname,
                "ObjectId": ObjectId,
                "ObjectType": Number(m_WriteDetails.objecttype),
                "PropertyId": PropertyId,
                "SiteId": Number(m_WriteDetails.siteid),
                "SiteName": m_WriteDetails.sitename,
                "KeyName": m_WriteDetails.propertyname,
                "IsCriticalPoint": false,
                "Value": l_setpoint_value
            }
            //        const l_Temperature = this.props.SaveTemperature(write_object); 
        }
    }

    ExecuteWidgetWrite() {
        var expiryTimer = setTimeout(() => {
            if (prev_Value === null || prev_Value !== write_object["Value"]) {
                prev_Value = write_object["Value"];
                const l_Temperature = this.props.SaveTemperature(write_object);
            }

        }, 5000);
    }    
    refreshComponent() {
        let ZoneId = localStorage.getItem('ZoneID');
        this.initialiseWidget(ZoneId);
    }
}

const mapStateToProps = state => {
    return {
        TempWidgetDetails: state.facilityRootReducer.TempWidgetDetails
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTemperatureWidgetDetails: (ID) => dispatch(GetTemperatureWidgetDetails(ID)),
        SaveTemperature: (data) => dispatch(SaveTemperature(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemperatureWidget);



//Code 0:  Widget enabled(working, both buttons enabled).
//Code 1:  points are offline or in Fault the widget is Disabled 
//Code 2:  Status Value is null
//Code 3:  when unoccupied or 'disabled' property of the controller is true
//Code 4:  if we aren't out of service, then check to see if we are overridden at a higher priority
//Code 5:  Comfort controls are not available for this space.